// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import axios from "axios";
import _ from "lodash";
import moment from "moment-timezone";
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts";
import styled from "styled-components";

import Select from "react-select";

import * as XLSX from "xlsx";

import { Control } from "components/ui-kit/control";

import EventsApi from "../../../api/events-api";

import { DormitoryTab } from "components/pages/dormitories-page";
import { Container, Row } from "components/ui-kit/styled-templates";

import UniversityApi from "api/university-api";

import useBodyBackground from "hooks/useBodyBackground";
import useQueryParams from "hooks/useQueryParams";
import { getDormitoryCompletnessProgress } from "hooks/useStepsOptions";
import { useStorageListener } from "hooks/useStorage";
import CommonHelper from "../../../services/common-service";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function getBookingsStatusesStats(bookings = []) {
    let map = {};
    for (let i in bookings) {
        let b = bookings[i];
        let { status } = b;
        if (map[status] == undefined) {
            map[status] = 0;
        }
        map[status] = +map[status] + 1;
    }
    return Object.keys(map).map((x) => ({ name: x, value: map[x] }));
}

export function getBookingsUnisStats(bookings = []) {
    let map = {};
    for (let i in bookings) {
        let b = bookings[i];
        let { universityId } = b;
        if (map[universityId] == undefined) {
            map[universityId] = 0;
        }
        map[universityId] = +map[universityId] + 1;
    }
    return Object.keys(map)
        .map((x) => ({ name: x, value: map[x] }))
        .sort((a, b) => +b.value - +a.value);
}

export function getDatesArr(from, to) {
    let dt = 86400000;
    let t = +from;
    let n = Math.ceil((+to - +from) / 86400000.0);
    return Array.from({ length: n })
        .map((a, i) => +from + +dt * i)
        .map((x) => moment(x).format("YYYY-MM-DD"));
}

export function perc2color(perc) {
    let xPerc = 100.0 - perc;
    let r,
        g,
        b = 0;
    if (xPerc < 50) {
        r = 255;
        g = Math.round(5.1 * xPerc);
    } else {
        g = 255;
        r = Math.round(510 - 5.1 * xPerc);
    }
    let h = r * 0x10000 + g * 0x100 + b * 0x1;
    return "#" + ("000000" + h.toString(16)).slice(-6);
}

export function getBookingsMatrixMap(bookings = []) {
    let map = {};
    for (let i in bookings) {
        let b = bookings[i];
        let { universityId } = b;
        let { from, to } = b?.dates || {};
        let start = +moment(from).startOf("day");
        let end = +moment(to).endOf("day");
        let dates = getDatesArr(start, end);
        for (let j in dates) {
            let date = dates[j];
            let key = `${universityId}_${date}`;
            if (map[key] == undefined) {
                map[key] = 0;
            }
            map[key] = +map[key] + 1;
        }
    }
    let maxVal = Object.keys(map).reduce((mx, v) => (mx < +map[v] ? +map[v] : +mx), 0);
    let enhMap = {};
    for (let key in map) {
        let v = map[key];
        let perc = maxVal == 0 ? 0 : (100.0 * v) / maxVal;
        enhMap[key] = { p: perc, value: +v, color: perc2color(perc) };
    }
    return enhMap;
}

function getEventBookingsStatsMap(bookings = []) {
    let map = {};
    for (let i in bookings) {
        let b = bookings[i];
        let { eventId } = b;
        if (map[eventId] == undefined) {
            map[eventId] = 0;
        }
        map[eventId] = +map[eventId] + 1;
    }
    return map;
}

const AdminStatsPage = () => {
    const { t } = useTranslation();
    const { params } = useQueryParams();
    const { universityId } = params;
    const navigate = useNavigate();
    useBodyBackground("white");
    const [allBookings, setAllBookings] = useState([]);
    const [allEvents, setAllEvents] = useState([]);
    const [allLabs, setAllLabs] = useState([]);

    const handleFromChange = (t) => {
        setRange((prevRange) => ({
            ...prevRange,
            from: t, // Convert Date object to Unix timestamp
        }));
    };

    const handleToChange = (t) => {
        setRange((prevRange) => ({
            ...prevRange,
            to: t, // Convert Date object to Unix timestamp
        }));
    };


    const [filterUniOption, setFilterUniOption] = useState("all");
    const [filterDormOption, setFilterDormOption] = useState("all");
    const [filterEventOption, setFilterEventOption] = useState("all");

    const [selectedEventId, setSelectedEventId] = useState(undefined);
    const [labsVisible, setLabsVisible] = useState(false);
    const [range, setRange] = useState({
        from: +moment().add(-3, "months").startOf("month").startOf("day"),
        to: +moment().endOf("year").startOf("day")
    });

    console.log("render: --->> range = ", range);

    const [dormitoriesProgress, setDormitoriesProgress] = useState({});
    const [usersStats, setUsersStats] = useState({ usersNumber: 0 });
    const [registrationRange, setRegistrationRange] = useState({
        from: null as number | null,
        to: null as number | null
    });

    const university = useStorageListener(`universities`, {});
    const dormitories = useStorageListener(`dormitories`, []);

    // Load users stats with date filter
    const loadUsersStats = () => {
        let url = "/stats/users-number";
        const params = new URLSearchParams();
        if (registrationRange.from) {
            params.append("dateFrom", String(registrationRange.from));
        }
        if (registrationRange.to) {
            params.append("dateTo", String(registrationRange.to));
        }
        if (params.toString()) {
            url += "?" + params.toString();
        }
        axios
            .get(url)
            .then((d) => d.data)
            .then((x) => {
                setUsersStats(x);
            });
    };

    const [unisMap, setUnisMap] = useState({});
    const [allEventsBookings, setAllEventsBookings] = useState([]);

    const selectedUniversity = _.get(university, universityId);

    const rows = _.values(dormitories)?.filter?.((i) => (!!universityId ? i?.universityId === universityId : true));

    // console.log("render: allBookings = ", allBookings);

    useEffect(() => {
        axios
            .get(`/bookings/all`)
            .then((d) => d.data)
            .then((arr) => {
                setAllBookings(arr);
                axios
                    .get("/universities/all")
                    .then((d) => d.data)
                    .then((arr) => {
                        console.log("all unis loaded!");
                        setUnisMap(arr.reduce((mp, x) => ({ ...mp, [x.id]: x?.details?.name }), {}));
                        loadUsersStats();
                        axios
                            .get("/labs/all")
                            .then((d) => d.data)
                            .then((x) => {
                                setAllLabs(x);
                            });
                    });
            });
    }, []);

    useEffect(() => {
        EventsApi.getEvents().then((arr) => {
            setAllEvents(arr);
        });
        EventsApi.getAllBookings().then((arr) => {
            setAllEventsBookings(arr);
        });
    }, []);

    useEffect(() => {
        (async () => {
            setDormitoriesProgress(_.zipObject(_.map(rows, `id`), await Promise.all(_.map(rows, `details`).map(getDormitoryCompletnessProgress))));
        })();
    }, [JSON.stringify(rows)]);

    // Reload users stats when registration date filter changes
    useEffect(() => {
        if (registrationRange.from !== null || registrationRange.to !== null) {
            loadUsersStats();
        }
    }, [registrationRange.from, registrationRange.to]);

    let fAllBookings = allBookings.filter((x) => {
        let from = +moment(x?.dates?.from);
        let to = +moment(x?.dates?.to);
        return from >= +range.from && to <= +range.to;
    });

    let fAllEventsBookings = allEventsBookings.filter((x) => {
        // let from = +moment(x?.dates?.from);
        // let to = +moment(x?.dates?.to);
        // return from >= +range.from && to <= +range.to;
        return (+x.timestamp > +range.from && +x.timestamp < +range.to);
    });

    let bStatsItems = getBookingsStatusesStats(fAllBookings);
    let evStatsItems = getBookingsStatusesStats(fAllEventsBookings);
    let unisStatsItems = getBookingsUnisStats(fAllBookings);

    let eventsUnisStatsItems = getBookingsUnisStats(fAllEventsBookings);

    let datesMatrix = getBookingsMatrixMap(allBookings);
    let minTimestamp = fAllBookings.map((x) => +moment(x?.dates?.from)).reduce((mn, x) => (mn > +x ? +x : +mn), +new Date());
    let maxTimestamp = fAllBookings.map((x) => +moment(x?.dates?.to)).reduce((mx, x) => (mx < +x ? +x : +mx), +new Date());
    let possibleDates = getDatesArr(minTimestamp, maxTimestamp);

    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);

    let evBookingsStatsMap = getEventBookingsStatsMap(fAllEventsBookings);
    let enhAllEvents = allEvents
        .map((x) => ({
            ...x,
            bNumber: evBookingsStatsMap[x.id] == undefined ? 0 : evBookingsStatsMap[x.id]
        }))
        .sort((a, b) => +b.bNumber - +a.bNumber);

    // ('render: allBookings = ', allBookings);
    const totalCount = fAllBookings.reduce((sm, x) => +sm + Math.min(+x.quantity, 20), 0);

    return (
        <Container extra="padding-top: 10px; align-items: flex-start;">
            <Row extra="gap: 15px;">
                {universityId && (
                    <DormitoryTab.Link color="blue" direction="left" onClick={() => navigate(-1)}>
                        {t("ecavxrhx1u")}
                    </DormitoryTab.Link>
                )}
                <h2>{t("p8ejjntqbw")}</h2>
            </Row>

            <UsersStatsSection>
                <p style={{ margin: 0, marginBottom: 10 }}>{`Зарегистрировано путешественников: ${(usersStats == undefined ? { usersNumber: 0 } : usersStats).usersNumber}`}</p>
                <RegistrationDateFilter>
                    <span style={{ fontSize: 14 }}>Фильтр по дате регистрации:</span>
                    <DateFilterRow>
                        <Control.Date
                            value={registrationRange.from}
                            onChange={(evt: any) => {
                                setRegistrationRange(prev => ({ ...prev, from: evt.target.value }));
                            }}
                            placeholder="С"
                        />
                        <span style={{ margin: '0 5px' }}>—</span>
                        <Control.Date
                            value={registrationRange.to}
                            onChange={(evt: any) => {
                                setRegistrationRange(prev => ({ ...prev, to: evt.target.value }));
                            }}
                            placeholder="По"
                        />
                        {(registrationRange.from || registrationRange.to) && (
                            <ClearFilterButton onClick={() => {
                                setRegistrationRange({ from: null, to: null });
                                loadUsersStats();
                            }}>
                                Сбросить
                            </ClearFilterButton>
                        )}
                    </DateFilterRow>
                </RegistrationDateFilter>
            </UsersStatsSection>

            <h2>{t("ssaf6zt05qd")}</h2>

            <p>{`Бронирований всего: ${fAllBookings.length}`}</p>
            <p>{`Количество человек в бронированиях: ${totalCount}`}</p>

            <ul>
                {bStatsItems.filter(x => (['done_visited', 'done_not_visited'].indexOf(x.name) > -1)).map((a, i) => {
                    return <li key={i}>{`${{done_visited: 'Исполнено:приехал', done_not_visited: 'Исполнено:не приехал', canceled: 'Отменено'}[a.name]} - ${a.value}`}</li>;
                })}
            </ul>

            <div style={{marginTop: 15, marginBottom: 15}} >
                  <span
                      style={{ cursor: "pointer", textAlign: "center", textDecoration: 'underline' }}
                      onClick={() => {
                          // Create a new workbook and a worksheet
                          const wb = XLSX.utils.book_new();
                          const ws = XLSX.utils.aoa_to_sheet([]);

                          // Adding headers to the worksheet
                          XLSX.utils.sheet_add_aoa(ws, [["Университет", "Бронирования", "Подтвержденные", "Отклоненные", "Новые", "В обработке", "Отмененные", "Исполнено-Приехал", "Испонено-Не приехал"]]);

                          unisStatsItems.forEach(a => {
                              let books = fAllBookings.filter((x) => a.name == x.universityId);
                              let approvedBooks = books.filter((x) => x.status == "approved");
                              let rejectedBooks = books.filter((x) => x.status == "rejected");
                              let newBooks = books.filter((x) => x.status == "new");
                              let reviewBooks = books.filter((x) => x.status == "review");
                              let canceledBooks = books.filter((x) => x.status == "canceled");

                              let done_visitedBooks = books.filter((x) => x.status == "done_visited");
                              let done_not_visitedBooks = books.filter((x) => x.status == "done_not_visited");

                              // Adding each row of data to the worksheet
                              XLSX.utils.sheet_add_aoa(ws, [[unisMap[a.name], books.length, approvedBooks.length, rejectedBooks.length, newBooks.length, reviewBooks.length, canceledBooks.length, done_visitedBooks.length, done_not_visitedBooks.length]], { origin: -1 });
                          });

                          // Adding the worksheet to the workbook
                          XLSX.utils.book_append_sheet(wb, ws, "Report");

                          // Generate a CSV file and trigger download
                          XLSX.writeFile(wb, "export.xlsx");
                      }}
                  >
                        создать отчет по размещениям
                    </span>
            </div>

            {/*<div>*/}
            {/*    <BarChart width={730} height={250} data={bStatsItems}>*/}
            {/*        <CartesianGrid strokeDasharray="3 3" />*/}
            {/*        <XAxis dataKey="name" />*/}
            {/*        <YAxis dataKey={"value"} />*/}
            {/*        <Tooltip />*/}
            {/*        <Bar dataKey="value" fill="#8884d8" />*/}
            {/*        <Legend />*/}
            {/*    </BarChart>*/}
            {/*</div>*/}

            <h2>{t("fhidxyhosr")}</h2>
            <p onClick={() => {
            }}>
                {`Всего: ${allLabs.length}`}
                <span
                    style={{ marginLeft: 10, fontSize: 10, opacity: 0.6, cursor: "pointer" }}
                    onClick={() => {
                        setLabsVisible(!labsVisible);
                    }}
                >
                    {labsVisible == false ? t("q1xcm5k4udi") : t("b8jh8xw1v2c")}
                </span>
            </p>

            {labsVisible == false ? null : (
                <div>
                    {allLabs.map((a, i) => {
                        return (
                            <EventItem
                                key={a.id}
                                onClick={() => {
                                    window.open(`https://студтуризм.рф/lab/${a.id}`, "_blank").focus();
                                }}
                            >
                                {a?.details?.name}
                            </EventItem>
                        );
                    })}
                </div>
            )}

            <h2>{t("x9rf80s5y8i")}</h2>

            <p>{`Событий всего: ${allEvents.length}`}</p>
            <p>{`Бронирований на события всего: ${fAllEventsBookings.length}`}</p>
            <ul>
                {evStatsItems.filter(x => (['done_visited', 'done_not_visited'].indexOf(x.name) > -1)).map((a, i) => {
                    return <li key={i}>{`${{done_visited: 'Исполнено:приехал', done_not_visited: 'Исполнено:не приехал', canceled: 'Отменено'}[a.name]} - ${a.value}`}</li>;
                })}
            </ul>

            <div style={{marginTop: 15, marginBottom: 15}} >
                <span className={'cursor-pointer'} style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => {
                    const wb = XLSX.utils.book_new();
                    const ws = XLSX.utils.aoa_to_sheet([]);

                    // Adding headers to the worksheet
                    XLSX.utils.sheet_add_aoa(ws, [["Университет", "Бронирования", "Подтвержденные", "Отклоненные", "Новые", "В обработке", "Отмененные", "Исполнено-Приехал", "Испонено-Не приехал"]]);

                    eventsUnisStatsItems.forEach(a => {
                        let books = fAllEventsBookings.filter((x) => a.name == x.universityId);
                        let approvedBooks = books.filter((x) => x.status == "approved");
                        let rejectedBooks = books.filter((x) => x.status == "rejected");
                        let newBooks = books.filter((x) => x.status == "new");
                        let reviewBooks = books.filter((x) => x.status == "review");
                        let canceledBooks = books.filter((x) => x.status == "canceled");

                        let done_visitedBooks = books.filter((x) => x.status == "done_visited");
                        let done_not_visitedBooks = books.filter((x) => x.status == "done_not_visited");

                        // Adding each row of data to the worksheet
                        XLSX.utils.sheet_add_aoa(ws, [[unisMap[a.name], books.length, approvedBooks.length, rejectedBooks.length, newBooks.length, reviewBooks.length, canceledBooks.length, done_visitedBooks.length, done_not_visitedBooks.length]], { origin: -1 });
                    });

                    // Adding the worksheet to the workbook
                    XLSX.utils.book_append_sheet(wb, ws, "Report");

                    // Generate a CSV file and trigger download
                    XLSX.writeFile(wb, "events_export.xlsx");
                }} >
                    скачать отчет по событиям
                </span>
            </div>

            {/*<div>*/}
            {/*    <BarChart width={730} height={250} data={evStatsItems}>*/}
            {/*        <CartesianGrid strokeDasharray="3 3" />*/}
            {/*        <XAxis dataKey="name" />*/}
            {/*        <YAxis dataKey={"value"} />*/}
            {/*        <Tooltip />*/}
            {/*        <Bar dataKey="value" fill="#8884d8" />*/}
            {/*        <Legend />*/}
            {/*    </BarChart>*/}
            {/*</div>*/}

            <div style={{ borderTop: "2px solid grey", height: 2 }}></div>

            <h3>{t("iico1u8yf4b")}</h3>

            <div style={{ marginTop: 30 }}>
                <div>
                    {unisStatsItems.map((a, i) => {
                        let books = fAllBookings.filter((x) => a.name == x.universityId);
                        let approvedBooks2 = books.filter((x) => x.status == "done_visited");
                        let approvedBooks = books.filter((x) => x.status == "approved");
                        let rejectedBooks = books.filter((x) => x.status == "rejected");
                        let newBooks = books.filter((x) => x.status == "new");
                        let reviewBooks = books.filter((x) => x.status == "review");
                        let canceledBooks = books.filter((x) => x.status == "canceled");
                        return (
                            <UniRow
                                key={i}
                                onClick={() => {
                                    let s = `approved=${approvedBooks.length} ; rejected=${rejectedBooks.length} ; new=${newBooks.length} ; review=${reviewBooks.length}; canceled=${canceledBooks.length}`;
                                    window.alert(s);
                                }}
                            >
                                <span>
                                    {`${+i + 1}`}) {unisMap[a.name]}
                                </span>
                                <span>
                                    {`${a.value}`}
                                    <span style={{ marginLeft: 10, fontSize: 10 }}>{`(${approvedBooks2.length})`}</span>
                                </span>
                            </UniRow>
                        );
                    })}
                </div>
            </div>

            <TableWrapper style={{ marginTop: 50 }}>
                <MyTable>
                    <thead>
                    <tr>
                        <th style={{ width: 400, fontSize: 10 }}>{t("ckuz715wkq9")}</th>
                        {possibleDates.map((x, i) => {
                            return <DatesSpanHead key={x}>{moment(x).format("DD.MM")}</DatesSpanHead>;
                        })}
                    </tr>
                    </thead>
                    <tbody>
                    {unisStatsItems.map((a, i) => {
                        let uniId = a.name;
                        return (
                            <MyTr key={i}>
                                <MyTd style={{ width: 400, fontSize: 10 }}>{unisMap[a.name]}</MyTd>
                                {possibleDates.map((x, j) => {
                                    let xKey = `${uniId}_${x}`;
                                    let mxData = datesMatrix[xKey];
                                    return (
                                        <MyTd
                                            key={x}
                                            color={mxData?.color}
                                            onClick={() => {
                                                let msg = `${x} - ${unisMap[uniId]} - ${mxData?.value == undefined ? "0" : mxData?.value}`;
                                                window.alert(msg);
                                            }}
                                        >
                                            {mxData?.value}
                                        </MyTd>
                                    );
                                })}
                            </MyTr>
                        );
                    })}
                    </tbody>
                </MyTable>
            </TableWrapper>

            <h3>{t("y9dqquioxr")}</h3>

            <div>
                {enhAllEvents.map((a, i) => {
                    return (
                        <EventItem key={a.id}>
                            <EventTop>
                                <EventName
                                    onClick={() => {
                                        setSelectedEventId(a.id);
                                    }}
                                >
                                    <div>
                                        {a?.details?.name}
                                        <span>{`(${a.bNumber})`}</span>
                                    </div>
                                    <div
                                        style={{ fontSize: 11, fontWeight: "bold", fontStyle: "italic", opacity: 0.5 }}>
                                        {unisMap[a.universityId]}
                                    </div>
                                </EventName>
                                <span>
                                    {/*<span onClick={() => {*/}
                                    {/*    setSelectedEventId(a?.id)*/}
                                    {/*}}>*/}
                                    {/*    бронирования*/}
                                    {/*</span>*/}
                                    <span style={{ marginLeft: 5 }} onClick={() => {
                                    }}>
                                        <Link to={`/events/${a.id}`}>
                                            <span>{t("ug4sql1hjm")}</span>
                                        </Link>
                                    </span>
                                </span>
                            </EventTop>
                        </EventItem>
                    );
                })}
            </div>

            <div style={{
                marginTop: 50,
                paddingTop: 10,
                paddingBottom: 30,
                position: "fixed",
                top: 80,
                right: 420,
                zIndex: 10,
                padding: "10px",
                backgroundColor: "white",
                boxShadow: "0px 0px 4px 4px rgba(0,0,0,0.33)"
            }}>

                <div>
                    {/*@ts-ignore*/}
                    {/*<Control.DateRange*/}
                    {/*    label="Период"*/}
                    {/*    value={range}*/}
                    {/*    onChange={x => {*/}
                    {/*        console.log("range: onChange: x = ", x);*/}
                    {/*        let newValue = x.target.value;*/}
                    {/*        if (newValue?.from != range?.from && newValue?.to != range?.to) {*/}
                    {/*            setRange(newValue);*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*/>*/}


                    {/*<div style={{ display: "flex", gap: "10px" }}>*/}
                    {/*    <DatePicker*/}
                    {/*        selected={new Date(range.from)} // Convert Unix timestamp to Date object*/}
                    {/*        onChange={handleFromChange}*/}
                    {/*        dateFormat="yyyy-MM-dd"*/}
                    {/*    />*/}
                    {/*    <DatePicker*/}
                    {/*        selected={new Date(range.to)} // Convert Unix timestamp to Date object*/}
                    {/*        onChange={handleToChange}*/}
                    {/*        dateFormat="yyyy-MM-dd"*/}
                    {/*    />*/}
                    {/*</div>*/}

                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginRight: "10px;" }}>
                            <Control.Date
                                value={range.from}
                                onChange={evt => {
                                    console.log("Date: onChange: evt = ", evt);
                                    handleFromChange(evt.target.value);
                                }}
                            />
                        </div>
                        <div>
                            <Control.Date
                                value={range.to}
                                onChange={evt => {
                                    console.log("Date: onChange: evt = ", evt);
                                    handleToChange(evt.target.value);
                                }}
                            />
                        </div>
                    </div>
                    {/*<p>*/}
                    {/*    Выбранный период:{" "}*/}
                    {/*    {`${moment(range.from).format("YYYY-MM-DD")} - ${moment(range.to).format(*/}
                    {/*        "YYYY-MM-DD"*/}
                    {/*    )}`}*/}
                    {/*</p>*/}

                </div>

                {/*<div style={{ marginBottom: 10 }}>*/}
                {/*    <div>*/}
                {/*        Вузы*/}
                {/*    </div>*/}
                {/*    <Select*/}
                {/*        placeholder={"Выбрать"}*/}
                {/*        options={[*/}
                {/*            {*/}
                {/*                label: "Все",*/}
                {/*                value: "all"*/}
                {/*            },*/}
                {/*            {*/}
                {/*                label: "Только не скрытые",*/}
                {/*                value: "not_hidden"*/}
                {/*            },*/}
                {/*            {*/}
                {/*                label: "Скрытые",*/}
                {/*                value: "hidden"*/}
                {/*            }*/}
                {/*        ]}*/}
                {/*        onChange={evt => {*/}
                {/*            setFilterUniOption(evt?.value);*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</div>*/}

                {/*<div style={{ marginBottom: 10 }}>*/}
                {/*    <div style={{ width: 300 }}>*/}
                {/*        Варианты размещения, события, объекты научной инфраструктуры*/}
                {/*    </div>*/}
                {/*    <Select*/}
                {/*        placeholder={"Выбрать"}*/}
                {/*        options={[*/}
                {/*            {*/}
                {/*                label: "Все",*/}
                {/*                value: "all"*/}
                {/*            },*/}
                {/*            {*/}
                {/*                label: "Только не скрытые",*/}
                {/*                value: "not_hidden"*/}
                {/*            },*/}
                {/*            {*/}
                {/*                label: "Скрытые",*/}
                {/*                value: "hidden"*/}
                {/*            }*/}
                {/*        ]}*/}
                {/*    />*/}
                {/*</div>*/}

                {/*<div style={{ marginBottom: 10 }}>*/}
                {/*    <div style={{ width: 300 }}>*/}
                {/*        Варианты размещения*/}
                {/*    </div>*/}
                {/*    <Select*/}
                {/*        placeholder={"Выбрать"}*/}
                {/*        options={[*/}
                {/*            {*/}
                {/*                label: "Все",*/}
                {/*                value: "all"*/}
                {/*            },*/}
                {/*            {*/}
                {/*                label: "C опцией «Доступно всегда»",*/}
                {/*                value: "not_hidden"*/}
                {/*            }*/}
                {/*        ]}*/}
                {/*        onChange={evt => {*/}
                {/*            setFilterDormOption(evt?.value);*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</div>*/}

                {/*<div style={{ marginBottom: 10 }}>*/}
                {/*    <div style={{ width: 300 }}>*/}
                {/*        События*/}
                {/*    </div>*/}
                {/*    <Select*/}
                {/*        placeholder={"Выбрать"}*/}
                {/*        onChange={evt => {*/}
                {/*            setFilterEventOption(evt?.value);*/}
                {/*        }}*/}
                {/*        options={[*/}
                {/*            {*/}
                {/*                label: "Все",*/}
                {/*                value: "all"*/}
                {/*            },*/}
                {/*            {*/}
                {/*                label: "C опцией «Доступно всегда»",*/}
                {/*                value: "not_hidden"*/}
                {/*            }*/}
                {/*        ]}*/}
                {/*    />*/}
                {/*</div>*/}


                {/*<Button>*/}
                {/*    /!*<span style={{ cursor: "pointer", textAlign: 'center' }} onClick={() => {*!/*/}
                {/*    /!*    let csv = `Университет;Бронирования;Подтвержденные;Отклоненные;Новые;В обработке;Отмененне`;*!/*/}
                {/*    /!*    for (let i in unisStatsItems) {*!/*/}
                {/*    /!*        let a = unisStatsItems[i];*!/*/}
                {/*    /!*        let books = allBookings.filter((x) => a.name == x.universityId);*!/*/}
                {/*    /!*        let approvedBooks = books.filter((x) => x.status == "approved");*!/*/}
                {/*    /!*        let rejectedBooks = books.filter((x) => x.status == "rejected");*!/*/}
                {/*    /!*        let newBooks = books.filter((x) => x.status == "new");*!/*/}
                {/*    /!*        let reviewBooks = books.filter((x) => x.status == "review");*!/*/}
                {/*    /!*        let canceledBooks = books.filter((x) => x.status == "canceled");*!/*/}
                {/*    /!*        csv = `${csv}\n${unisMap[a.name]};${books.length};${approvedBooks.length};${rejectedBooks.length};${newBooks.length};${reviewBooks.length};${canceledBooks.length}`;*!/*/}
                {/*    /!*    }*!/*/}
                {/*    /!*    CommonHelper.downloadFile(`export.csv`, csv);*!/*/}
                {/*    /!*}}>*!/*/}
                {/*    /!*    создать отчет*!/*/}
                {/*    /!*</span>*!/*/}

                {/*  */}

                {/*</Button>*/}
            </div>

        </Container>
    );
};

const Button = styled.div`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  /* or 125% */

  justify-content: center;

  text-align: center;

  display: flex;
  align-items: center;
  text-align: center;
  background: #00A19A;
  border-radius: 46px;
  color: white;
  padding: 15px;
  padding-left: 30px;
  padding-right: 30px;
  cursor: pointer;
`;

const EventName = styled.div``;

const EventDetails = styled.div``;

const EventTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const EventItem = styled.div`
  padding: 5px;
  box-sizing: border-box;
  margin-bottom: 5px;
  border: 1px solid lightgrey;
  margin-bottom: 5px;
`;

const TableWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
`;

const MyTable = styled.table`
  border-collapse: collapse;
  border: 1px solid lightgrey;
`;

const MyTr = styled.tr`
  :hover {
    background: lightgoldenrodyellow;
  }
`;

const MyTd = styled.td`
  border: 1px solid lightgrey;
  text-align: center;
  background: ${(props) => (props.color == undefined ? "white" : props.color)};
`;

const DatesSpanHead = styled.th`
  text-align: center;
  white-space: nowrap;
  font-size: 10px;
  border: 1px solid lightgrey;
`;

const UniRow = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  :hover {
    background: whitesmoke;
  }
`;

const UsersStatsSection = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
`;

const RegistrationDateFilter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
`;

const DateFilterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
`;

const ClearFilterButton = styled.button`
  background: none;
  border: 1px solid #ddd;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  margin-left: 10px;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
    border-color: #ccc;
  }
`;

export default AdminStatsPage;
